import { render } from "./BackingInformationListItem.vue?vue&type=template&id=48b0454e"
import script from "./BackingInformationListItem.vue?vue&type=script&lang=js"
export * from "./BackingInformationListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__